import { skipToken, useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { AnlageStromStg } from "../utils/backend-types";

export function useAnlageStromstg(anlageStromstgId?: number) {
  return useQuery({
    queryKey: ["anlageStromStg", { anlageStromstgId }],
    queryFn: anlageStromstgId
      ? () => fetchAnlageStromStg(anlageStromstgId)
      : skipToken
  });
}

export async function fetchAnlageStromStg(anlageStromstgId: number) {
  const anlageUrl = urls.api.anlagenStromstgDetailUrl(anlageStromstgId);
  const response = await api.get<AnlageStromStg>(anlageUrl);

  return response.data;
}
